import React from 'react';

const imagePath = (path, fileName) => `${path}/${fileName}.png`;

const PaymentIcon = (props) => {
  const { provider } = props;
  const path = `${props.path}/${provider}`;
  const src = imagePath(path, `${provider}_icon`);
  const srcSet = `${src} 1x, ${imagePath(path, `${provider}_icon@2x`)} 2x`;
  const altText = `${provider} icon`;
  const widthAndHeight = {};
  if (props.width && props.height) {
    widthAndHeight.width = props.width;
    widthAndHeight.height = props.height;
  }
  return (
    <img
      className={props.className}
      src={src}
      srcSet={srcSet}
      alt={altText}
      {...widthAndHeight}
    />
  );
};

export default PaymentIcon;
